import { CustomerApi } from './customer.api';

const customerApi = new CustomerApi();

export { customerApi };
